<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <b-row>
      <b-col md="9">
        <collection-image-show
          :id="id"
          :api_path="api_path"
        ></collection-image-show>
      </b-col>
      <b-col md="3">
        <item-list-card
          :data_item="item"
          :mappings="association_items"
          :included="association_included"
          :api_path="api_path"
        ></item-list-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, amsApiResourcePath, apiRoute, IMAGES_WITH_PRODUCTS, ITEM_IMAGE_ASSOCIATIONS} from '@/ams_route'
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import CollectionImageShow from './CollectionImageShow.vue'
import ItemListCard from './ItemListCard'

export default {
  components: {
    VuexBreadcrumb,
    CollectionImageShow,
    ItemListCard
  },
  props: {
    id: String,
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      attr_copy: {},
      attr_orig: {},
      item: {},
      association_items: [],
      association_included: [],
    }
  },
  methods: {
    apiPath () {
       return this.api_path ? this.api_path : ADMIN_PATH
    },
    apiResourcePath() {
      return amsApiResourcePath(this.apiPath(), ITEM_IMAGE_ASSOCIATIONS)
    },
    getItems () {
      http_v1.get (
        this.apiResourcePath(), {
          params: {
            collection_image_ids: this.id,
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.association_items = response.data.data
          this.association_included = response.data.included
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.association_items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    callApi () {
      http_v1.get(apiRoute(amsApiResourcePath(this.apiPath(), IMAGES_WITH_PRODUCTS), this.id)
, {
      }).then(response => {
        if( response.data) {
          this.attr_copy = Object.assign( {}, response.data.data.attributes)
          this.attr_orig = Object.assign( {}, response.data.data.attributes)
          this.item = Object.assign( {}, response.data.data )
          this.included = response.data.included
          this.getItems()
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
  },
  mounted () {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    this.callApi()
  }
}
</script>